import { useCallback } from 'react';
import useAnalyticsClient from './use-analytics-client';

// Single component-facing tracking API. Each method maps to one typed
// client.track(...) call; the package fires the PostHog and TeacherTotter
// parity events together, so call sites never talk to a provider directly.
const useTracking = () => {
  const client = useAnalyticsClient();

  const trackAssignmentConfirmed = useCallback((count) => {
    if (client) client.track('assignment.confirmation', { type: 'assign', count });
  }, [client]);

  const trackAssignmentUnassigned = useCallback((count) => {
    if (client) client.track('assignment.confirmation', { type: 'unassign', count });
  }, [client]);

  const trackQuickPreview = useCallback(() => {
    if (client) client.track('preview.quick', {});
  }, [client]);

  const trackReviewAssessment = useCallback(() => {
    if (client) client.track('preview.assessment', {});
  }, [client]);

  const trackGoToNewAssessments = useCallback(() => {
    if (client) client.track('navigation.go-to-new-assessments', {});
  }, [client]);

  const trackFillLearningGaps = useCallback(() => {
    if (client) client.track('learninggaps.open', {});
  }, [client]);

  const trackCourseFilter = useCallback(() => {
    if (client) client.track('filter.course', {});
  }, [client]);

  const trackAssessmentTypeFilter = useCallback(() => {
    if (client) client.track('filter.assessment-type', {});
  }, [client]);

  const trackClassFilter = useCallback(() => {
    if (client) client.track('filter.class', {});
  }, [client]);

  const trackGroupFilter = useCallback(() => {
    if (client) client.track('filter.group', {});
  }, [client]);

  const trackGridCheckboxClick = useCallback((isChecked) => {
    if (client) client.track('grid.checkbox-click', { is_checked: isChecked });
  }, [client]);

  const trackSelectAll = useCallback((isAllSelected) => {
    if (client) client.track('grid.select-all', { is_all_selected: isAllSelected });
  }, [client]);

  return {
    trackAssignmentConfirmed,
    trackAssignmentUnassigned,
    trackQuickPreview,
    trackReviewAssessment,
    trackGoToNewAssessments,
    trackFillLearningGaps,
    trackCourseFilter,
    trackAssessmentTypeFilter,
    trackClassFilter,
    trackGroupFilter,
    trackGridCheckboxClick,
    trackSelectAll
  };
};

export default useTracking;
